import {FETCH_STUDENT_COURSES_DURATION_DATA} from '../constants/student-courses-duration-data';

export function fetchStudentCoursesDurationData() {
  return ({
    type: FETCH_STUDENT_COURSES_DURATION_DATA,
    api: true,
    auth: true,
    payload: {
      method: 'GET',
      url: `/students/student-courses/data/duration`
    }
  });
}
